export const STORAGE = {
  LANGUAGE: 'LANGUAGE',
  USER_TOKEN: 'USER_TOKEN',
  USER_NAME: 'USER_NAME',
  DRIVE_TOKEN: 'DRIVE_TOKEN',
  META_DATA: 'META_DATA',
  ROLE: 'ROLE',
  PLAN: 'PLAN',
  FAEnabled: 'ENABLE_2FA',
  IS_CHECK2FA: 'IS_CHECK2FA',
  IS_SHOW_HEADER_LAYOUT_SETTING: 'IS_SHOW_HEADER_LAYOUT_SETTING',
  USER_AVATAR: 'USER_AVATAR',
  USER_MAIL: 'USER_MAIL'
}

export const LOGIN_MODE = {
  LABEL: 'LOGIN_MODE',
  BASIC: 'BASIC',
  GOOGLE: 'GOOGLE',
  MS: 'MS'
}

export function getLocalStorage(key) {
  return localStorage.getItem(key)
}

export function setLocalStorage(key, value) {
  return localStorage.setItem(key, value)
}

export function removeLocalStorage(key) {
  return localStorage.removeItem(key)
}

export function clearLocalStorage() {
  return localStorage.clear()
}
